import type { FC, SetStateAction } from "react";
import { useState } from "react";
import { UserRoundCog } from "lucide-react";

import { useUpdateSubscription } from "@/api/stripe";
import GenericModal from "@/components/modals/generic-modal";
import { RadioGroupCustom } from "@/components/radio-group-custom";

interface SubscriptionTierModalProps {
  currentPriceId: string;
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
}

const priceIdOptionsStaging: Array<{
  value: string;
  label: string;
}> = [
  {
    value: "price_1SebwnFZ7CP02e8kMH8aD6bz",
    label: "Complet mensuel : 69€/mois",
  },
  {
    value: "price_1SebwnFZ7CP02e8kK7G8jj9v",
    label: "Complet annuel : 699€/an",
  },
];

const priceIdOptionsProduction: Array<{
  value: string;
  label: string;
}> = [
  {
    value: "price_1SexZLFDjE9cPZZTp5WcK8Q1",
    label: "Complet mensuel : 69€/mois",
  },
  {
    value: "price_1SexZLFDjE9cPZZThXk0rEVX",
    label: "Complet annuel : 699€/an",
  },
];

const SubscriptionTierModal: FC<SubscriptionTierModalProps> = ({
  currentPriceId,
  open,
  setOpen,
}) => {
  const isProduction = import.meta.env.VITE_NODE_ENV === "production";

  const priceIdOptions = isProduction
    ? priceIdOptionsProduction
    : priceIdOptionsStaging;

  const [priceId, setPriceId] = useState(currentPriceId);

  const { mutateAsync: updateSubscription, isPending } =
    useUpdateSubscription();

  const handleSubmit = async () => {
    await updateSubscription(priceId);
    setOpen(false);
  };

  return (
    <GenericModal
      title="Modifier mon abonnement"
      description="Choisissez un autre abonnement"
      submitLabel="Confirmer"
      logo={<UserRoundCog />}
      open={open}
      setOpen={setOpen}
      handleSubmit={handleSubmit}
      isSubmitPending={isPending}
    >
      <div className="px-4">
        <RadioGroupCustom
          options={priceIdOptions}
          value={priceId}
          onValueChange={setPriceId}
        />
      </div>
    </GenericModal>
  );
};

export default SubscriptionTierModal;
